/**
 * Created by yarik on 18.7.17.
 */
import lazyLoading from './lazyLoading'

export default {
  name: 'sharedTrip',
  meta: {
    expanded: false,
    title: 'VIAJE COMPARTIDO',
    iconClass: 'vuestic-icon vuestic-icon-auth'
  },
  children: [
    {
      name: 'sharedTrip',
      path: '/share/:travelId',
      component: lazyLoading('sharedTrip/Main'),
      meta: {
        title: 'Programados',
        requiresAuth: false
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/sharedTrip.js